export const CONFIG_SUCCESS = "CONFIG_SUCCESS";
export const CONFIG_FAIL = "CONFIG_FAIL";
